module.exports = __webpack_public_path__ + "img/Ghana.9c073e5d.png";